import { Injectable } from '@angular/core';
import { PlanoState } from '../states/plano.state';
import { IPlano } from '../types/IPlano';
import { PlanoService } from '../services/plano.service';
import { LightboxesService } from '../components/lightboxes/lightboxes.service';
import { IOperadora } from '../types/IGetPlanosResponse';

@Injectable({ providedIn: 'root' })
export class PlanoFacade {
  constructor(
    private planoState: PlanoState,
    private planoService: PlanoService,
    private lightboxesService: LightboxesService,
  ) { }

  requestPlanos() {
    this.planoState.setIsRequestingPlanos(true);

    this.planoService.getPlanos().subscribe(
      response => this.planoState.setPlanos(response),
      error => this.error("Não foi possível consultar os planos disponíveis. Tente novamente mais tarde."),
      () => this.planoState.setIsRequestingPlanos(false)
    );
  }

  selectPlano(plano: IPlano) {
    this.planoState.selectPlano(plano);
  }

  selectOriginalPlano(plano: IPlano) {
    this.planoState.selectOriginalPlano(plano);
  }

  getPlanoSelecionado() {
    return this.planoState.getPlanoSelecionado();
  }

  getOperadoras(): IOperadora[] {
    return this.planoState.getPlanos();
  }

  filterByUf(ufDescription: string) {
    this.planoState.filterByUf(ufDescription);
  }

  clearFilter() {
    this.planoState.clearFilter();
  }

  observePlanoSelecionado() {
    return this.planoState.observePlanoSelecionado();
  }

  error(msg: string) {
    this.lightboxesService.open({
      title: 'Atenção',
      text: msg,
    }, 30_000);
  }
}